import { z } from "zod";

import { zOut as zBaseOut } from "./common";

import { ListParams, Pagination } from "~/shared/zod";

const zOut = Pagination.Page.zSchema(zBaseOut);
type Out = z.infer<typeof zOut>;

const zFieldsToSortBy = z.enum(["id", "email", "phone", "username", "firstName", "lastName"]);
const FieldsToSortBy = zFieldsToSortBy.Enum;
type FieldsToSortBy = z.infer<typeof zFieldsToSortBy>;

const zIn = ListParams.zSchema(zFieldsToSortBy);
type In = z.infer<typeof zIn>;

export { FieldsToSortBy, zFieldsToSortBy, zIn, zOut };
export type { In, Out };
